// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BE97S","label":"styles_label__6Etxc"};